module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/progress_02-20a700ce6fa999d024884b4f0c08a1aa.png";